export default __webpack_public_path__ + "static/media/errorMobile.073b27f1.png";